'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleDrop = require('./handleDrop');

var _handleDrop2 = _interopRequireDefault(_handleDrop);

var _createDecorator = require('./createDecorator');

var _createDecorator2 = _interopRequireDefault(_createDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createBlockDndPlugin = function createBlockDndPlugin() {
  var store = {
    getReadOnly: undefined
  };
  return {
    initialize: function initialize(_ref) {
      var getReadOnly = _ref.getReadOnly;

      store.getReadOnly = getReadOnly;
    },
    decorator: (0, _createDecorator2.default)({ store: store }),
    // Handle blocks dragged and dropped across the editor
    handleDrop: _handleDrop2.default
  };
};

exports.default = createBlockDndPlugin;


//////////////////
// WEBPACK FOOTER
// ./~/draft-js-drag-n-drop-plugin/lib/index.js
// module id = 1761
// module chunks = 0